import "core-js/modules/es6.object.assign";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { Icon } from '../Icon';
import { IconStyle } from '../types';

var Image = function Image() {
  return React.createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M22 7L12 17 2 7",
    "data-stroke": "1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export var IconCaretDown = Object.assign(React.forwardRef(function (props, ref) {
  return React.createElement(Icon, __assign({
    ref: ref
  }, props, {
    defaultStroke: Icon.Stroke.Dark
  }), React.createElement(Image, null));
}), {
  displayName: 'IconCaretDown',
  iconStyle: IconStyle.Stroke
});